type ApplicationStatus = "pending" | "approved" | "rejected" | "in-review" | "in-interview";


export default function UserApplicationCard({
    application,
    onViewDetail,
    lang = "en",
}: {
    application: any
    onViewDetail: () => void;
    lang?: "en" | "id";
}) {
    const formatDate = (date: string) =>
        new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });

    const status = application.status as ApplicationStatus;

    const statusLabel: Record<ApplicationStatus, string> = {
        approved: lang === "id" ? "Diterima ✓" : "Approved ✓",
        rejected: lang === "id" ? "Ditolak ✕" : "Rejected ✕",
        pending: lang === "id" ? "Dalam Peninjauan ⏳" : "In Review ⏳",
        "in-review": lang === "id" ? "Direview ⏳" : "Reviewed ⏳",
        "in-interview": lang === "id" ? "Interview ⏳" : "Interviewed ⏳",
    };

    const statusColor: Record<ApplicationStatus, string> = {
        approved: "bg-green-100 text-green-700",
        rejected: "bg-red-100 text-red-700",
        pending: "bg-blue-100 text-blue-700",
        "in-review": "bg-yellow-100 text-yellow-700",
        "in-interview": "bg-purple-100 text-purple-700",
    };


    return (
        <div
            className="flex flex-col sm:flex-row gap-4 sm:items-center border rounded-xl p-4 shadow-sm hover:shadow-md hover:border-primary transition cursor-pointer"
            onClick={onViewDetail}
        >
            <img
                src={application.companyLogo || "https://placehold.co/100x100"}
                alt="Company Logo"
                className="w-16 h-16 rounded-lg object-cover"
            />

            {/* TEXT + STATUS WRAPPER */}
            <div className="flex-1">
                <h3 className="font-semibold text-lg">{application.positionApplied}</h3>
                <p className="text-gray-600">{lang === "id" ? "Tipe Pekerjaan: " : "Working Type: "}{application.workingType}</p>
                <p className="text-gray-600">{lang === "id" ? "Jenis Pekerjaan: " : "Job Type: "}{application.jobType}</p>
                <p className="text-gray-600">{application.companyName}</p>
                <p className="text-gray-600">{application.country}, {application.state}, {application.city}</p>

                <p className="text-sm mt-2 text-gray-500">
                    Applied on{" "}
                    <span className="font-medium text-gray-700">
                        {formatDate(application.appliedDate)}
                    </span>
                </p>

                {/* Status for MOBILE */}
                <span
                    className={`mt-3 sm:hidden inline-block px-3 py-1 rounded-lg text-sm font-medium ${statusColor[status]}`}
                >
                    {statusLabel[status]}
                </span>
            </div>

            {/* Status for DESKTOP */}
            <span
                className={`hidden sm:inline-block px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap ${statusColor[status]}`}
            >
                {statusLabel[status]}
            </span>
        </div>
    );

}
